var $slider;
$slider = $('.js-row-slider');
$slider.flickity({
  pageDots: false,
  contain: false,
  cellAlign: 'center',
  percentPosition: false,
  dragThreshold: 3,
  prevNextButtons: true,
  groupCells: false,
  wrapAround: true,
  selectedAttraction: 0.01,
  friction: 0.15,
  freeScrollFriction: 0.02
});


// WEBPACK FOOTER //
// ./scripts/components/sliders/row-slider.js